import { GetOcr } from 'shared/data/webApp/v2';

export const ocrDocumentIsEmpty = (document?: GetOcr['response']['document']) =>
    document &&
    Object.values(document).every(
        (value) => value === '' || value === null || (Array.isArray(value) && value.length === 0)
    );
